import React, { createContext, useContext, useState, useEffect } from 'react';
import { installFetchSession } from './fetchSession';

// Tüm /api/ isteklerine token ekler, süresi dolan oturumu kapatır (bkz. fetchSession.js)
installFetchSession();

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Sayfa yüklendiğinde localStorage'dan kullanıcıyı kontrol et
    const storedUser = localStorage.getItem('ramada_user');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  // Başka sekmede çıkış / yeniden giriş: bu sekmenin oturumu da güncellensin (yoksa okumalar token'sız 401 alıp
  // ekran yarı çalışır kalıyordu). Oturum kapandıysa PrivateRoute giriş ekranına yönlendirir.
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key !== 'ramada_user' && e.key !== null) return;
      try {
        const next = localStorage.getItem('ramada_user');
        setCurrentUser(next ? JSON.parse(next) : null);
      } catch {
        setCurrentUser(null);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';

  // Oturum token'ı ve süresi dolmuş oturum kontrolü: fetchSession.js (modül yüklenirken kurulur)

  const login = async (email, password) => {
    console.log("Giriş isteği gönderiliyor:", `${API_URL}/login`);
    const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    });

    // Yanıtın JSON olup olmadığını kontrol et
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") === -1) {
        const text = await response.text();
        console.error(`API Hatası (${API_URL}/login): Sunucu JSON yerine HTML döndürdü.`, text.substring(0, 200));
        throw new Error("Sunucu hatası: API servisine erişilemiyor. Lütfen sunucu yapılandırmasını kontrol edin.");
    }

    if (!response.ok) {
        let errorMessage = 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.';
        try {
            const errorData = await response.json();
            if (errorData.message) errorMessage = errorData.message;
        } catch (e) {}
        throw new Error(errorMessage);
    }

    const user = await response.json();
    localStorage.setItem('ramada_user', JSON.stringify(user));
    setCurrentUser(user);
    return user;
  };

  const logout = async () => {
    localStorage.removeItem('ramada_user');
    setCurrentUser(null);
  };

  const value = {
    currentUser,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
